import modalTypes from '../components/Modals/modalTypes'

export const getUi = state => state.ui
export const getUiModal = state => state.ui.modal
export const getUiModalIsOpen = state => !!state.ui.modal.id
export const getUiModalIs = ( state, modalId ) => state.ui.modal.id === modalId
export const getUiModalIsStoriesList = state => getUiModalIs( state, modalTypes.STORIES_LIST )
export const getUiModalIsPublish = state => getUiModalIs( state, modalTypes.PUBLISH )
export const getUiAudioIsRecording = state => state.ui.audioIsRecording
